module.exports = __webpack_public_path__ + "img/bg768.5290862d.png";